/**
 * Privacy Extension for WhatsApp Privacy
 *
 * Exposes its injected CSS/images (`css/*`, `images/*`, …) as static web-accessible
 * resources, scoped to `*.whatsapp.com`. Detectable only from WhatsApp Web, where it
 * runs. `css/noDelay.css` is vendor-named and reachable there at a fixed URL.
 *
 * Manifest verified against version 2.0.10.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cgipcgghboamefelooajpiabilddemlh';

export const privacyExtensionWhatsapp: ExtensionDefinition = {
  id: ID,
  name: 'Privacy Extension for WhatsApp Privacy',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  requiredOrigin: 'https://web.whatsapp.com',
  notes:
    'Injected stylesheets are static WAR scoped to *.whatsapp.com, so only WhatsApp Web ' +
    'can detect it. A single fetch there is conclusive.',
  signals: [
    {
      id: 'war-nodelay-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch css/noDelay.css — one of the extension\'s injected stylesheets, exposed ' +
        'only to whatsapp.com origins.',
      weight: 1,
      run: () => probeFetch(ID, 'css/noDelay.css'),
    },
    {
      id: 'war-profilepic-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/profilePic.css — a second WhatsApp-scoped stylesheet.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/profilePic.css'),
    },
  ],
};
